<template>
  <el-container>
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :filter="filter"
          :limits="limits"
          :columns-property="columnsProperty"
          module="basic"
          url="projects"
          @delete="deleteHandle"
          @addOrEdit="addEditHandle"
          @select="selectHandle"
          @reset="resetHandle">
        <template slot="otherBtn">
          <el-button :disabled="!selection.length" type="primary" :loading="submitLoading" @click="projectSubmit"> 提交 </el-button>
          <el-button v-if="limits.delAuth" :disabled="!selection.length" type="danger" @click="deleteRows"> 批量删除 </el-button>
        </template>
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @submit.native.prevent @keyup.enter.native="loadData(1)">
            <el-form-item label="项目编号">
              <el-input v-model.trim="filter.projectNo" placeholder="请输入项目编号" clearable/>
            </el-form-item>
            <el-form-item label="项目名称">
              <el-input v-model.trim="filter.projectName" placeholder="请输入项目名称" clearable/>
            </el-form-item>
            <el-form-item label="负责人">
              <el-input v-model.trim="filter.projectManagerName" placeholder="请输入负责人名称" clearable/>
            </el-form-item>
            <el-form-item label="项目状态">
              <el-select v-model="filter.status" clearable placeholder="请选择项目状态">
                <el-option label="待提交" :value="10"/>
                <el-option label="未开始" :value="20"/>
                <el-option label="进行中" :value="30"/>
                <el-option label="已完工" :value="40"/>
              </el-select>
            </el-form-item>
          </el-form>
        </template>
        <template slot="actionBtn" slot-scope="scope">
          <el-button type="success" @click="$refs.editPage.open(scope.row, true)"> 详情 </el-button>
        </template>
      </view-table>
      <project-edit ref="editPage" @save-success="loadData(1)"/>
    </el-main>
  </el-container>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";
  import ProjectEdit from "./ProjectEdit.vue";
  export default {
    name: "ProjectManagementList",
    components: { ProjectEdit, ViewTable},
    data() {
      return {
        selection: [],
        filter: {
          projectNo:"",
          projectName:"",
          projectManagerName:"",
          status:"",
        },
        submitLoading: false,
        limits:{
          addAuth: this.$auth(328),
          editAuth: this.$auth(329),
          delAuth: this.$auth(332),
        },
        userId: JSON.parse(localStorage.getItem("step_user_info")).userId,
        columnsProperty:[
          {
            key:"projectNo",
            align:"center",
          },
          {
            key:"projectName",
            align:"center",
          },
          {
            key:"projectManagerName",
            align:"center",
          },
          {
            key:"statusName",
            align:"center",
          },
          {
            key:"planBeginDate",
            align:"center",
            width:120,
            render:(h, params) => {
              return h(
                "span",
                params.row.planBeginDate ? params.row.planBeginDate.substring(0, 10) :"",
              );
            },
          },
          {
            key:"planEndDate",
            align:"center",
            width:120,
            render:(h, params) => {
              return h(
                "span",
                params.row.planEndDate ? params.row.planEndDate.substring(0, 10) :"",
              );
            },
          },
          {
            key:"createTime",
            align:"center",
            width:160,
          },
          {
            key: "action",
            align: "center",
            width: 200,
            slot: "action",
            fixed: "right",
          },
        ],
      };
    },

    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },

      // 新增、编辑
      addEditHandle(row) {
        this.$refs.editPage.open(row);
      },

      selectHandle(selection) {
        this.selection = selection;
      },

      projectSubmit() {
        const arr = this.selection.filter((item) => item.status !== 10);
        if (arr.length) {
          this.$confirm("请选择待提交的项目", "错误", {
            type: "error",
            showCancelButton: false,
          });
        } else {
          this.$confirm("确认提交吗?", "提示", { type: "warning" }).then(() => {
            this.submitLoading = true;
            let ids = [];
            this.selection.forEach((item) => {
              ids.push(item.pkId);
            });
            this.$http
              .post("basic", "projects/submit", ids)
              .then((resp) => {
                if (resp.success) {
                  this.$message.success("提交成功");
                  this.selection = [];
                  this.loadData(1);
                }
                this.submitLoading = false;
              })
              .catch(() => {
                this.submitLoading = false;
              });
          });
        }
      },

      deleteHandle(row) {
        this.$http.delete("basic", "projects", row.pkId).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      },

      deleteRows() {
        let ids = [];
        this.selection.forEach((item) => {
          ids.push(item.pkId);
        });
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.post("basic", "projects/deleteBatch", ids).then((resp) => {
            if (resp.success) {
              this.loadData(1);
              this.$message.success("删除成功");
              this.selection = [];
            }
          });
        });
      },

      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
    },
  };
</script>
